export const bodyObjectBuilder = (page, queryList, filters = {}) => {
  const basicObj = {
    pageSize: 30,
    pageNumber: page,
    queries: [
    ]
  };
  const queryArray = []
  // if a query is empty, we avoid sending it to the server
  if(queryList.length) {
    queryList.forEach(el => {
      if(el.query?.length > 0) queryArray.push(el)
    });
  }
  if(queryArray.length) basicObj.queries = [...queryArray]
  if(Object.keys(filters).length) {
    Object.keys(filters).forEach(filter=>{
      basicObj[filter] = filters[filter]
    })
  }
  return basicObj
}